import subscriptionsCountriesList from './actions/countriesList';
import subscriptionsGetCountries from './getters/getCountries';
import subscriptionsUploadCountries from './mutations/uploadCountries';

const actions = {
    subscriptionsCountriesList
};

const mutations = {
    subscriptionsUploadCountries
};

const getters = {
    subscriptionsGetCountries
};

export default { actions, mutations, getters };
